import React, { useEffect, useState } from "react";
import { Container, MainDiv, PopupDiv, Title } from "./style";
import {
  VerticalLeftAlign,
  SpaceBetween,
  HorizontalLeftAlign,
  BoldHeading,
  BoldLgPri,
  BoldMedPri,
  VerticalAlign,
  HorizontalAlign,
  RegMedPri,
  RegSmPri,
  BoldHeadingPri,
} from "../../../../Components/CustomStyles";
import { useSelector, useDispatch } from "react-redux";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import ReactPlayer from "react-player";
import { FileUploader } from "react-drag-drop-files";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { BackIcon } from "../CourseDetails/styles";
import AssignmentIcon from "@mui/icons-material/Assignment";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import VideocamIcon from "@mui/icons-material/Videocam";
import Colors from "../../../../Constant/Colors";
import IconButton from "../../../../Components/IconButton";
import ModalComponent from "../../../../Components/Modal";
import QuizComponent from "../../../../Components/QuizComponent";
import SmartImage from "../../../../Components/SmartImage";
import {
  deleteContentRequest,
  getQuizDetailsRequest,
  patchContentReorderRequest,
  postContentRequest,
} from "../../../../Redux/actions/home";
import ClipLoader from "react-spinners/ClipLoader";
import Dropdown from "../../../../Components/DropDownPop";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { EachContent } from "../CourseList/styles";
import images from "../../../../Constant/images";
import axios from "axios";

const CourseMaterials = ({ handleView, selectedMaterial, course }) => {
  const dispatch = useDispatch();
  const [isLastContent, setIsLastContent] = useState(false);
  const [isFirstContent, setIsFirstContent] = useState(true);
  const { isInstructor } = useSelector((state) => state.auth);
  const [onUploadProgress, setUploadProgress] = useState({
    count: 0,
    isStart: false,
  });

  const [contentTypes] = useState([
    {
      id: 0,
      title: "Photos",
      type: "jpg/png",
    },
    {
      id: 1,
      title: "Videos",
      type: "mp4",
    },
    {
      id: 2,
      title: "Notes",
      type: "doc/docx/pdf",
    },
    {
      id: 3,
      title: "Quiz",
      type: "Multiple Choice",
    },
  ]);
  let { contentLoading, courseContent, isContentUpload } = useSelector(
    (state) => state.home
  );

  const [items, setItems] = useState([{ label: "Delete" }]);
  const [material, setMaterial] = useState(null);
  const [openModal, setOpenModal] = useState({
    isOpen: false,
    type: "",
    showContentModal: false,
  });
  const [contentList, setContentList] = useState([]);
  const [file, setFile] = useState(null);
  const fileTypes =
    openModal?.type === "Photos"
      ? ["JPG", "PNG"]
      : openModal?.type === "Videos"
      ? ["MP4"]
      : ["docx", "pdf"];

  const handleChange = (file) => setFile(file);

  const style = {
    icon: (head) => ({
      color: head.isSelected ? head.color : Colors.whiteThemeColor,
      fontSize: 16,
    }),
    btnTxt: (head) => ({
      color: head.isSelected ? head.color : Colors.whiteThemeColor,
      marginLeft: 10,
    }),
    icon2: (color) => ({ color, fontSize: 25 }),
  };

  const handleOpenModal = (isOpen, type, mat) => {
    if (mat?.content_type === "text" && isOpen) {
      window.open(mat?.file_url, "_blank");
    } else {
      if (mat?.id) {
        let arr = [...contentList];
        arr = arr.filter((f) => f.content_type !== "text" && !f.is_submitted);
        let currMatInd = arr.findIndex((f) => f.id === mat?.id);
        setIsFirstContent(currMatInd === 0);
        setIsLastContent(currMatInd === arr.length - 1);
      }
      setMaterial(mat);

      setOpenModal({ type, isOpen });
    }
  };

  const uploadDoc = async () => {
    let file_url = await uploadFileToS3();

    let data = {
      course: parseInt(course?.id),
      con_type: selectedMaterial.title.toLowerCase(),
      title: file?.name,
      file_url,
      content_type:
        openModal?.type === "Videos"
          ? "video"
          : openModal?.type === "Photos"
          ? "image"
          : "text",
    };

    dispatch(postContentRequest(data));
    setTimeout(() => setFile(), 10);
  };

  const uploadFileToS3 = async () => {
    if (!file) return;

    let fileName = file.name;
    const fileType = file.type;
    fileName = fileName.replace(/ /g, "_");

    // Step 1: Request presigned URL from backend
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/course/content/s3/url/`,
      {
        file_name: fileName,
        file_type: fileType,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const presignedUrl = data.url;

    // Step 2: Upload the file directly to S3 using the presigned URL
    await axios.put(presignedUrl, file, {
      headers: {
        "Content-Type": fileType,
      },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        if (percentCompleted === 100) {
          setUploadProgress({ isStart: false, count: percentCompleted });
        } else {
          setUploadProgress({ isStart: true, count: percentCompleted });
        }
      },
    });

    // Step 3: After successful upload, save the file URL in the backend (Optional)
    const fileUrl = `https://e-learning-s3.s3.amazonaws.com/media/content/${fileName}`;

    return fileUrl;
  };

  const closeModal = () => {
    handleOpenModal("", false);
    setMaterial(null);
  };

  const handleBackBtn = () => {
    if (course?.id) {
      handleView("details", course);
    } else {
      handleView("list");
    }
  };

  const optionSelect = (option, item) => {
    if (option?.label === "Delete") {
      let data = {
        id: item?.id,
        cor_id: course?.id,
        type: item?.content_type ? "content" : "quiz",
      };
      dispatch(deleteContentRequest(data));
    } else if (option?.label === "Details") {
      course["quiz"] = item?.quiz_title;
      dispatch(getQuizDetailsRequest(item?.id));
      handleView("quizDetails", course, null, item?.quiz_title);
    } else {
      handleOpenModal(true, item?.content_type ?? "quiz", item);
    }
    // setMaterial(null);
  };

  const changeIndex = (oldIndex, newIndex) => {
    let arr = [...contentList];
    if (
      oldIndex < 0 ||
      oldIndex >= arr.length ||
      newIndex < 0 ||
      newIndex >= arr.length
    ) {
      throw new Error("Index out of bounds");
    }
    // Remove the object from its current position
    const [movedObject] = arr.splice(oldIndex, 1);
    // Insert the object at the new index
    arr.splice(newIndex, 0, movedObject);
    setContentList(arr);
    let tempArr = [];
    arr.forEach((e, i) => {
      let obj = {};
      if (e.content_type) {
        obj = { [`content-${e?.id}`]: `order-${i}` };
      } else {
        obj = { [`quiz-${e?.id}`]: `order-${i}` };
      }
      tempArr.push(obj);
    });
    let result = tempArr.reduce((acc, current) => {
      // Iterate over the keys of the current object
      Object.keys(current).forEach((key) => {
        acc[key] = current[key]; // Add the key-value pair to the accumulator object
      });
      return acc; // Return the accumulator for the next iteration
    }, {});

    dispatch(
      patchContentReorderRequest(course?.id, result, selectedMaterial?.title)
    );
  };

  const onDragEnd = (result) => {
    const { source, destination } = result;

    // Return if the item is dropped outside the list
    if (!destination) {
      return;
    } else {
      changeIndex(source?.index, destination?.index);
    }

    // Reorder logic here
    const updatedContent = Array.from(courseContent);
    const [movedItem] = updatedContent.splice(source.index, 1);
    updatedContent.splice(destination.index, 0, movedItem);
  };

  const openSelectContModal = () =>
    setOpenModal((prev) => ({ ...prev, showContentModal: true }));
  const closeSelectContModal = () =>
    setOpenModal((prev) => ({ ...prev, showContentModal: false }));

  const selectContent = (title) => {
    setMaterial(null);
    setOpenModal((prev) => ({ ...prev, showContentModal: false }));
    handleOpenModal(true, title);
    closeSelectContModal();
  };
  const addNew = () => {
    setMaterial(null);
    handleOpenModal(true, selectedMaterial?.title);
  };

  const handleNextMaterial = (type) => {
    let arr = [...contentList];
    arr = arr.filter((f) => f.content_type !== "text" && !f.is_submitted);

    let currMatInd = arr.findIndex((f) => f.id === material.id);
    let nxtMatInd = currMatInd + 1;
    let prevMatInd = currMatInd - 1;
    let mat = {};

    if (type === "next") {
      setIsFirstContent(false);
      mat = arr[currMatInd + 1];
      setMaterial(mat);

      if (nxtMatInd == arr.length) {
        closeModal();
        return;
      }
      if (nxtMatInd + 1 === arr.length) {
        setIsLastContent(true);
      }
    }
    if (type === "prev") {
      setIsFirstContent(prevMatInd === 0);
      mat = arr[currMatInd - 1];
      setMaterial(mat);

      setIsLastContent(false);
    }
    setOpenModal({ type: mat?.content_type, isOpen: true });
  };

  useEffect(() => {
    if (material?.content_type) {
      setItems([{ label: "View" }, { label: "Delete" }]);
    } else {
      setItems([{ label: "Details" }, { label: "Delete" }]);
    }
  }, [material]);

  useEffect(() => {
    if (courseContent.length) {
      setContentList(courseContent);
    }
  }, [courseContent]);
  useEffect(() => {
    if (isContentUpload) handleOpenModal("", false);
  }, [isContentUpload]);
  // console.log(material, contentList);

  return (
    <Container>
      <HorizontalLeftAlign style={{ marginTop: 10, marginBottom: 10 }}>
        <BackIcon onClick={handleBackBtn} style={{ marginBottom: -8 }}>
          <KeyboardBackspaceIcon />
        </BackIcon>
        <BoldHeading style={{ textTransform: "capitalize" }}>
          {course?.title ?? course?.name}
        </BoldHeading>
      </HorizontalLeftAlign>
      {/* -------------------------- Material List ------------------------------ */}
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided) => (
            <MainDiv {...provided.droppableProps} ref={provided.innerRef}>
              {contentLoading ? (
                <VerticalAlign style={{ height: 100 }}>
                  <ClipLoader color={Colors.primary} size={20} />
                </VerticalAlign>
              ) : courseContent.length ? (
                <VerticalAlign style={{ width: "100%" }}>
                  {contentList.length &&
                    contentList.map((material, i) => (
                      <Draggable
                        key={material?.id.toString()}
                        draggableId={material?.id.toString()}
                        index={i}
                        isDragDisabled={!isInstructor}
                      >
                        {(provided) => (
                          <SpaceBetween
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={{
                              width: "100%",
                              marginTop: 20,
                              ...provided.draggableProps.style,
                            }}
                          >
                            <HorizontalLeftAlign style={{ width: "40%" }}>
                              {material?.content_type === "image" ? (
                                <CameraAltIcon
                                  style={style.icon2(Colors.photoIcon)}
                                />
                              ) : material?.content_type === "text" ? (
                                <AssignmentIcon
                                  style={style.icon2(Colors.AssIcon)}
                                />
                              ) : material?.content_type === "video" ? (
                                <VideocamIcon
                                  style={style.icon2(Colors.vidIcon)}
                                />
                              ) : (
                                <SmartImage
                                  src={images.quiz}
                                  style={{ height: 30, width: 30 }}
                                />
                              )}
                              <Title>
                                <BoldLgPri>
                                  {material?.quiz_title ?? material?.title}
                                </BoldLgPri>
                              </Title>
                            </HorizontalLeftAlign>
                            <HorizontalLeftAlign>
                              <VerticalLeftAlign>
                                <BoldMedPri>Created At:</BoldMedPri>
                                <BoldMedPri>
                                  {dayjs(material?.created_at).format(
                                    "MMM D, YYYY"
                                  )}
                                </BoldMedPri>
                              </VerticalLeftAlign>
                            </HorizontalLeftAlign>
                            {isInstructor ? (
                              <Dropdown
                                items={items}
                                onItemClick={(e) => optionSelect(e, material)}
                                position={"right"}
                                alignment={"left"}
                                onToggle={() => setMaterial(material)}
                              />
                            ) : (
                              <IconButton
                                text={
                                  material?.content_type === "image"
                                    ? "View"
                                    : material?.content_type === "video"
                                    ? "Play"
                                    : material?.quiz_title &&
                                      material?.is_submitted
                                    ? `${material?.score}%`
                                    : material?.quiz_title &&
                                      dayjs().format("MM DD, YYYY") >
                                        dayjs(course?.end_date).format(
                                          "MM DD, YYYY"
                                        )
                                    ? "Not Available"
                                    : material?.quiz_title &&
                                      !material?.is_submitted
                                    ? "Attempt"
                                    : "Download"
                                }
                                style={{
                                  width: 80,
                                  backgroundColor:
                                    material?.quiz_title &&
                                    material?.is_submitted
                                      ? Colors.whiteThemeColor
                                      : Colors.primary,
                                  border: `1px solid ${Colors.primary}`,
                                }}
                                disabled={
                                  (material?.quiz_title &&
                                    dayjs().format("MM DD, YYYY") >
                                      dayjs(course?.end_date).format(
                                        "MM DD, YYYY"
                                      )) ||
                                  (material?.quiz_title &&
                                    material?.is_submitted)
                                }
                                textStyle={{
                                  color:
                                    material?.quiz_title &&
                                    material?.is_submitted
                                      ? Colors.primary
                                      : Colors.whiteThemeColor,
                                }}
                                onClick={() =>
                                  handleOpenModal(
                                    true,
                                    material?.content_type ?? "Quiz",
                                    material
                                  )
                                }
                              />
                            )}
                          </SpaceBetween>
                        )}
                      </Draggable>
                    ))}
                  {provided.placeholder}
                </VerticalAlign>
              ) : (
                <HorizontalAlign style={{ marginTop: 20 }}>
                  <RegMedPri>No {selectedMaterial?.title} to show</RegMedPri>
                </HorizontalAlign>
              )}
            </MainDiv>
          )}
        </Droppable>
      </DragDropContext>
      <div
        style={{
          width: "100%",
          paddingLeft: 60,
          backgroundColor: Colors.whiteThemeColor,
          position: "relative",
          bottom: 0,
        }}
      >
        {isInstructor && new Date().toISOString() < course?.end_date && (
          <IconButton
            text={"Add New"}
            style={{ width: 100 }}
            onClick={
              material?.quiz_title
                ? () => addNew()
                : () => openSelectContModal()
            }
          />
        )}
      </div>
      {openModal?.isOpen && (
        <ModalComponent
          closeModal={closeModal}
          openModal={openModal?.isOpen}
          disabledYesBtn={!file || onUploadProgress?.isStart}
          heading={`${
            isInstructor && !material?.content_type ? `Upload ` : ""
          }${isInstructor ? openModal?.type.toUpperCase() : material?.title}`}
          yesBtnTxt={
            onUploadProgress?.isStart
              ? `${onUploadProgress?.count}%`
              : isInstructor
              ? openModal?.type === "Quiz"
                ? null
                : `Upload ${openModal?.type}`
              : null
          }
          yesBtn={
            isInstructor && !material
              ? openModal?.type === "Quiz"
                ? null
                : () => uploadDoc()
              : null
          }
          loading={contentLoading}
        >
          <PopupDiv>
            {openModal?.type === "Quiz" || material?.quiz_title ? (
              <QuizComponent
                course={course}
                closeModal={closeModal}
                quiz={material}
              />
            ) : material && material?.content_type === "video" ? (
              <ReactPlayer
                url={material?.file_url ?? material?.file}
                playing
                loop
                controls={true}
              />
            ) : material && material?.content_type === "image" ? (
              <SmartImage
                src={material?.file_url ?? material?.file}
                style={{ height: "50%", width: "100%" }}
              />
            ) : (
              <FileUploader
                handleChange={handleChange}
                name="file"
                types={fileTypes}
                maxSize={500}
                onTypeError={(e) => toast.error(e)}
                onSizeError={(e) => toast.error(e)}
              />
            )}
            {!isInstructor && (
              <SpaceBetween style={{ marginTop: 10 }}>
                {isFirstContent ? (
                  <div></div>
                ) : (
                  <IconButton
                    text={"Previous"}
                    style={{ width: 100 }}
                    onClick={() => handleNextMaterial("prev")}
                  />
                )}
                <IconButton
                  text={isLastContent ? "Finish" : "Next"}
                  style={{ width: 100 }}
                  onClick={() => handleNextMaterial("next")}
                />
              </SpaceBetween>
            )}
          </PopupDiv>
        </ModalComponent>
      )}
      {openModal?.showContentModal && (
        <ModalComponent
          closeModal={closeModal}
          openModal={openModal?.showContentModal}
          heading={"Select Content's type to Upload"}
        >
          <SpaceBetween>
            {contentTypes.map((content, i) => (
              <EachContent onClick={() => selectContent(content?.title)}>
                {content?.id === 0 ? (
                  <CameraAltIcon />
                ) : content?.id === 1 ? (
                  <VideocamIcon />
                ) : content?.id === 2 ? (
                  <AssignmentIcon />
                ) : (
                  <SmartImage
                    src={images.quiz}
                    style={{ height: 30, width: 30 }}
                  />
                )}
                <BoldHeadingPri>{content?.title}</BoldHeadingPri>
                <RegSmPri>{content?.type}</RegSmPri>
              </EachContent>
            ))}
          </SpaceBetween>
        </ModalComponent>
      )}
    </Container>
  );
};

export default CourseMaterials;
